(function () {
  function initFaqAccordion(section) {
    if (!section) return;

    var mode = section.getAttribute('data-accordion-mode');
    var items = section.querySelectorAll('.custom-faq__item');

    if (!items.length) return;

    if (mode !== 'single') return;

    items.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;

        items.forEach(function (otherItem) {
          if (otherItem !== item) {
            otherItem.removeAttribute('open');
          }
        });
      });
    });
  }

  function initAllFaqAccordions() {
    var sections = document.querySelectorAll('[data-faq-section]');

    sections.forEach(function (section) {
      if (section.dataset.faqInitialized === 'true') return;

      section.dataset.faqInitialized = 'true';
      initFaqAccordion(section);
    });
  }

  document.addEventListener('DOMContentLoaded', initAllFaqAccordions);

  document.addEventListener('shopify:section:load', function () {
    initAllFaqAccordions();
  });
})();